import { computed, debug, NetbankingAPI, observable } from "aaa";
import { action } from "mobx";
import { CardAPIClient } from "network/APIClient";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { IGetCreditCardUpgradeResponse } from "types/card";
import { ISigningInfo } from "types/signing";
import { ContactsStore } from "../../stores/ContactsStore";

export class CreditCardUpgradeStore {
    @observable contactsStore: ContactsStore;
    @observable upgradeDetails?: IGetCreditCardUpgradeResponse;
    @observable signInfo?: ISigningInfo;

    // Needed only for platforms using PdfViewer component for rendering (currently only Android)
    pdfData?: Uint8Array;

    @observable _isLoading = true;

    constructor() {
        this.contactsStore = new ContactsStore();
    }

    @computed get isLoading() {
        return this._isLoading
            || this.contactsStore.isLoading;
    }

    @action async loadData() {
        try {
            this._isLoading = true;

            await Promise.all([
                this.contactsStore.load(),
                this.getUpgradeDetails(),
            ]);

            this._isLoading = false;
        } catch (error) {
            debug.log("[CreditCardUpgradeStore] loadData error:", error);

            throw error;
        }
    }

    @action getUpgradeDetails = async () => {
        try {
            if (externalInterfaceStore.currentCardId) {
                const target = NetbankingAPI.getUpgradeDetails(externalInterfaceStore.currentCardId);
                const upgradeDetails = await CardAPIClient.requestType(target);

                this.upgradeDetails = upgradeDetails;
            }
        } catch (error) {
            this._isLoading = false;
            throw error;
        }
    }

    @action postUpgrade = async () => {
        if (
            !this.upgradeDetails?.card?.id ||
            !this.contactsStore.selectedAddressId ||
            !this.contactsStore.selectedEmailAddressId
        ) {
            return;
        }

        try {
            this._isLoading = true;

            const target = NetbankingAPI.postUpgrade(
                this.upgradeDetails?.card?.id,
                this.contactsStore.selectedAddressId,
                this.contactsStore.selectedEmailAddressId
            );

            const response = await CardAPIClient.requestType(target);
            this.signInfo = response.signInfo;

            this._isLoading = false;
        } catch (error) {
            this._isLoading = false;
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradeStore.ts